import { Guest } from '@/entities/Guest'
import { GuestRequests } from '@/services/guest.requests'
const guestService = new GuestRequests()

import Vue from 'vue'

const state = {
  list: [],
  read: null,
  edited: null
}
const getters = {}

const actions = {
  get ({}, { id }) {
    return new Promise((resolve, reject) => {
      guestService.get(id).then((guest) => {
        resolve(guest)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  save ({ state, commit }, { profileId, bookingId, active }) {
    return new Promise((resolve, reject) => {
      var read = state.read || new Guest()
      commit('setField', { field: 'profileId', value: profileId })
      commit('setField', { field: 'bookingId', value: bookingId })
      commit('setField', { field: 'active', value: active })
      guestService.save(read.serialize(state.edited)).then((id) => {
        commit('resetEdited')
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setRead (state, profile) {
    state.read = profile
  },
  setField (state, { field, value }) {
    if (!state.edited) {
      state.edited = {}
      if (state.read && state.read.id) {
        Vue.set(state.edited, 'id', state.read.id)
      }
    }
    Vue.set(state.edited, field, value)
  },
  resetEdited (state) {
    state.edited = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
